
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.36 2.367a.963.963 0 01-.72-.297 1.085 1.085 0 01-.28-.765c0-.308.093-.56.28-.758a.95.95 0 01.72-.305c.286 0 .523.102.71.305.193.198.29.45.29.758 0 .307-.097.562-.29.765a.937.937 0 01-.71.297zm4.765 0a.963.963 0 01-.719-.297 1.085 1.085 0 01-.281-.765c0-.308.094-.56.281-.758a.95.95 0 01.719-.305c.286 0 .523.102.71.305.194.198.29.45.29.758 0 .307-.096.562-.29.765a.937.937 0 01-.71.297zm0 2.125c.286 0 .523.102.71.305.194.198.29.45.29.758 0 .307-.096.562-.29.765a.937.937 0 01-.71.297.963.963 0 01-.719-.297 1.085 1.085 0 01-.281-.765c0-.308.094-.56.281-.758a.95.95 0 01.719-.305zm-4.766 0c.287 0 .524.102.711.305.193.198.29.45.29.758 0 .307-.097.562-.29.765a.937.937 0 01-.71.297.963.963 0 01-.72-.297 1.085 1.085 0 01-.28-.765c0-.308.093-.56.28-.758a.95.95 0 01.72-.305z","fill":"currentColor"}})])
          )
        }
      }
    